import React from "react";
import { Page } from "../layout/page";
import { PageList } from "../components/pageList";
import { useTableSchema } from "../hooks/useTableSchema";
import { useFormSchema } from "../hooks/useFormSchema";

const Task = ({ title = "Task" }) => {
  const [getTableSchema] = useTableSchema();
  const [getFormSchema] = useFormSchema();

  return (
    <PageList
      title={title}
      apiEntity={"task"}
      tableSchema={getTableSchema("task")}
      formSchema={getFormSchema("task")}
      showImport={false}
      initSort={{ by: "code", order: "desc" }}
      // searchByTextField={true}
      // stats={{
      //   component: ProjecPageStats,
      //   props: {
      //     mb: 35,

      //   },
      // }}
    />
  );
};

export default Task;
